import { Star, ShieldCheck, MapPinned, Award } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { SOCIAL_LINKS } from "@/components/site/SocialIcons";
import { Instagram, Facebook } from "lucide-react";

const GOOGLE_REVIEWS_URL = "https://share.google/ekl7JyqjDHVMoHyLw";

const REAL_REVIEWS = [
  { name: "Sheetal Gholap", text: "Staff in the hotel was polite, food quality was good." },
  { name: "javed parmar", text: "Affordable price, Service of the team is very good." },
  { name: "Mukesh Nagar", text: "However we inquired, they tackle with their calm and customer friendly attitude." },
];

export function TrustBar() {
  const stats = [
    { icon: Star, label: "4.8 \u2605 Google Rating", sub: "478+ Reviews" },
    { icon: MapPinned, label: "25+ Curated Packages", sub: "6 Regions Covered" },
    { icon: Award, label: "Trusted Since 2018", sub: "Experienced Local Team" },
    { icon: ShieldCheck, label: "Secure Enquiry Process", sub: "No Hidden Charges" },
  ];
  return (
    <div className="border-b bg-white">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-2 gap-4 px-4 py-5 sm:px-6 md:grid-cols-4 lg:px-8">
        {stats.map((s, i) => (
          <div key={i} className="flex items-center gap-2.5">
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[hsl(var(--brand-primary))]/10">
              <s.icon className="h-4.5 w-4.5 text-[hsl(var(--brand-primary))]" />
            </div>
            <div>
              <p className="text-xs font-semibold leading-tight text-slate-800 sm:text-sm">{s.label}</p>
              <p className="text-[11px] text-slate-500">{s.sub}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function TestimonialsAndFollowSection() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
      <div className="mb-8 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
        <div>
          <h2 className="font-display text-xl font-semibold text-slate-900 sm:text-2xl">Loved by Real Travellers</h2>
          <p className="mt-1 text-sm text-slate-500">Genuine reviews collected from our Google Business profile.</p>
        </div>
        <a href={GOOGLE_REVIEWS_URL} target="_blank" rel="noopener noreferrer" data-testid="google-reviews-link">
          <Button variant="outline" className="gap-2 min-h-11">
            <Star className="h-4 w-4 fill-[hsl(var(--brand-accent))] text-[hsl(var(--brand-accent))]" />
            4.8/5 &middot; Read All 478 Reviews
          </Button>
        </a>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {REAL_REVIEWS.map((r, i) => (
          <Card key={i} data-testid="testimonial-card" className="p-5">
            <div className="mb-2 flex gap-0.5">
              {Array.from({ length: 5 }).map((_, idx) => (
                <Star key={idx} className="h-3.5 w-3.5 fill-[hsl(var(--brand-accent))] text-[hsl(var(--brand-accent))]" />
              ))}
            </div>
            <p className="text-sm leading-relaxed text-slate-600">&quot;{r.text}&quot;</p>
            <p className="mt-3 text-sm font-semibold text-slate-800">{r.name}</p>
            <p className="text-xs text-slate-400">Google Review</p>
          </Card>
        ))}
      </div>

      {/* Follow us */}
      <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2">
        <a
          href={SOCIAL_LINKS.instagram}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="follow-instagram-card"
          className="social-follow-card group flex items-center justify-between gap-3 rounded-xl border bg-gradient-to-br from-[#f58529]/10 via-[#dd2a7b]/10 to-[#8134af]/10 p-5 transition-shadow hover:shadow-[var(--shadow-card)]"
        >
          <div className="flex min-w-0 items-center gap-3">
            <div className="flex h-11 w-11 items-center justify-center rounded-full bg-gradient-to-br from-[#f58529] via-[#dd2a7b] to-[#8134af]">
              <Instagram className="h-5 w-5 text-white" />
            </div>
            <div>
              <p className="font-semibold text-slate-900">@best.escape.holidays</p>
              <p className="text-xs text-slate-500">1.5K+ followers &middot; Follow our journey</p>
            </div>
          </div>
          <span className="inline-flex min-h-11 shrink-0 items-center rounded-md bg-slate-900 px-3 text-sm font-medium text-white group-hover:bg-slate-800">Follow</span>
        </a>
        <a
          href={SOCIAL_LINKS.facebook}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="follow-facebook-card"
          className="social-follow-card group flex items-center justify-between gap-3 rounded-xl border bg-[#1877F2]/5 p-5 transition-shadow hover:shadow-[var(--shadow-card)]"
        >
          <div className="flex min-w-0 items-center gap-3">
            <div className="flex h-11 w-11 items-center justify-center rounded-full bg-[#1877F2]">
              <Facebook className="h-5 w-5 text-white" />
            </div>
            <div>
              <p className="font-semibold text-slate-900">Best Escape Holidays</p>
              <p className="text-xs text-slate-500">2.3K+ followers &middot; Like our page</p>
            </div>
          </div>
          <span className="inline-flex min-h-11 shrink-0 items-center rounded-md bg-primary px-3 text-sm font-medium text-primary-foreground">Like</span>
        </a>
      </div>
    </section>
  );
}
